module.exports = __webpack_public_path__ + "img/vermas.5afd384e.png";